import { ValueFormatterParams } from "ag-grid-community";
import React, { useCallback, useRef, useState } from "react";
import PlusButtonIcon from "../../../../assets/images/PlusButtonIcon.svg";
import Grid from "../../../../components/Grid";
import { ColumnDef } from "../../../../components/Grid/model/Grid";
import ModalDelete from "../../../../components/ModalDelete";
import Loading from "../../../../core/common/Loading";
import { formatDateBR, formatDateTimeBR } from "../../../../helpers/format";
import { useModal } from "../../../../hooks/ModalContext";
import api from "../../../../services/api";
import Create from "./Create";
import { IOperacoesPatioEntradaVeiculos } from "./Create/types/types";
import Info from "./Info";
import ExportModal from "./ExportModal";
import ExportIcon from "../../../../assets/images/exportIcon.svg";
import ModalHistory from "../../../../components/ModalHistory";
import Can from "../../../../components/Can";

// import { Container } from './styles';

const OperacoesPatioEntradaVeiculos: React.FC = () => {
  const [columns] = useState<ColumnDef[]>([
    {
      field: "data_hora",
      headerName: "Data/Hora Entrada",
      filter: true,
      type: "dateColumn",
      valueFormatter: (params: ValueFormatterParams) => {
        if (params.value) {
          return formatDateTimeBR(params.value);
        }
        return "---";
      },
    },
    {
      field: "placa_dianteira",
      headerName: "Placa Dianteira",
      filter: true,
      valueFormatter: (params: ValueFormatterParams) => {
        if (params.value) {
          return params.value.toUpperCase();
        }
        return "---";
      },
    },
    {
      field: "cancela.numero_cancela",
      headerName: "Cancela Entrada",
      filter: true,
      valueFormatter: (params: ValueFormatterParams) => {
        if (params.value) {
          return params.value;
        }
        return "---";
      },
    },
    {
      field: "saida.data_hora",
      headerName: "Data/Hora Saída",
      filter: true,
      type: "dateColumn",
      valueFormatter: (params: ValueFormatterParams) => {
        if(params.value) {
          return formatDateTimeBR(params.value);
        }
        return "---";
      }
    },
    {
      field: "saida.placa_dianteira",
      headerName: "Placa Dianteira Saída",
      filter: true,
      valueFormatter: (params: ValueFormatterParams) => {
        if(params.value) {
          return params.value;
        }
        return "---";
      }
    },
    {
      field: "saida.cancela.numero_cancela",
      headerName: "Cancela Saída",
      filter: true,
      valueFormatter: (params: ValueFormatterParams) => {
        if (params.value) {
          return params.value;
        }
        return "---";
      },
    },
    {
      field: "usuario",
      headerName: "Usuário",
      filter: true,
      valueFormatter: (params: ValueFormatterParams) => {
        if (params.value) {
          return params.value;
        }
        return "---";
      },
    },
    {
      field: "data_historico",
      headerName: "Data de Modificação",
      filter: true,
      filterParams: {
        dateBetween: true,
      },
      valueFormatter: (params: ValueFormatterParams) => {
        if (params.value) {
          return formatDateBR(params.value);
        }
        return "----";
      },
    },
  ]);
  const [isRemove, setIsRemove] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);
  const [selectedRow, setSelectedRow] = useState<IOperacoesPatioEntradaVeiculos>();
  const [isView, setIsView] = useState<boolean>(false);
  const [isEdit, setIsEdit] = useState<boolean>(false);
  const [isHistory, setIsHistory] = useState<boolean>(false);
  const [isExportModalOpen, setIsExportModalOpen] = useState<boolean>(false);

  const gridRef: any = useRef();

  const { openModal, closeModal, isModalOpen } = useModal();

  const onDelete = useCallback(async (rowId?: number) => {
    try {
      setLoading(true);
      const body = {
        id_operacao_patio_entrada_veiculo: rowId,
      };

      await api.post("/deletar/entradaSaidaVeiculos", body);

      setLoading(false);

      setIsRemove(false);

      gridRef.current?.refresh();
    } catch {
      setLoading(false);
    }
  }, []);

  return (
    <>
      <Loading loading={loading} />

      {isModalOpen && (
        <Create
          isEdit={isEdit}
          isView={isView}
          selectedRow={selectedRow}
          onClear={() => closeModal()}
          onConfirm={() => {
            closeModal();
            gridRef.current?.refresh();
          }}
        />
      )}

      {isRemove && (
        <ModalDelete
          onCancel={() => setIsRemove(!isRemove)}
          onConfirm={() => onDelete(selectedRow?.id_operacao_patio_entrada_veiculo)}
          row={selectedRow?.placa_dianteira}
        />
      )}

      {isView && (
        <Info
          data={selectedRow}
          title="Conhecer - Entrada e Saída de Veiculos"
          onClose={() => setIsView(!isView)}
        />
      )}

      {isHistory && selectedRow && (
        <ModalHistory
          isOpen={isHistory}
          title="Histórico - Entrada e Saída de Veículos"
          historyRoute="/historico/entradaSaidaVeiculos"
          bodyKey="id_entrada_saida"
          bodyValue={selectedRow.id_operacao_patio_entrada_veiculo}
          onClose={() => setIsHistory(false)}
        />
      )}

      <ExportModal
        isOpen={isExportModalOpen}
        onClose={() => setIsExportModalOpen(false)}
        currentFilters={gridRef.current?.getFilters() || {}}
      />

      <div className="flex flex-col w-full h-screen bg-[#F5F5F5] p-5">
        <div className="flex items-center justify-between w-full mb-3">
          <div>
            <h1 className="text-2xl text-[#000000] font-bold">Entrada e Saída de Veículos</h1>
          </div>
          <div className="mr-14 flex items-center gap-4">
            <Can acao="EXPORTAR">
            <button
              className="flex items-center justify-center h-12 w-36 bg-[#062D4E] text-[#FFFFFF] text-sm font-light border-none rounded-full gap-2 hover:bg-[#0a3d6a] transition-colors"
              onClick={() => setIsExportModalOpen(true)}
            >
              Exportar
              <img src={ExportIcon} alt="" className="w-4 h-4 invert" />
            </button>
            </Can>
            <Can acao="SALVAR">
            <button
              className="flex items-center justify-center h-12 w-36 bg-[#062D4E] text-[#FFFFFF] text-sm font-light border-none rounded-full"
              onClick={() => openModal()}
              id="btnCreate"
            >
              Adicionar <img src={PlusButtonIcon} alt="" className="ml-2" />
            </button>
            </Can>
          </div>
        </div>
        <div className="flex w-full">
          <Grid
            ref={gridRef}
            columns={columns}
            filters={[]}
            pagination
            path="/listar/entradaSaidaVeiculos"
            onDelete={(data: any) => {
              setIsRemove(!isRemove);
              setSelectedRow(data);
            }}
            status={[]}
            onView={(data: any) => {
              setSelectedRow(data);
              setIsView(!isView);
            }}
            onUpdate={(data: any) => {
              setSelectedRow(data);
              setIsEdit(!isEdit);
              openModal();
            }}
            onHistory={(data: any) => {
              setSelectedRow(data);
              setIsHistory(true);
            }}
          />
        </div>
      </div>
    </>
  );
};

export default OperacoesPatioEntradaVeiculos;

